import { Link } from 'react-router-dom'
import { css, useTheme } from '@fable/theme'
import { FlexBox } from '@fable/components'
import peopleChatting from '../../../../assets/images/graphics/people/people-chatting.webp'
import { routes as marketingRoutes } from '../../../marketing/routes'

const ProfileClubsEmptyState = () => {
  const { colors, fonts } = useTheme()

  return (
    <FlexBox
      centerAll
      flexDirection="column"
      className={css`
        padding: 144px 0px 250px 0px;
      `}
    >
      <img
        src={peopleChatting}
        alt="People chatting"
        className={css`
          margin-bottom: 10px;
        `}
      />
      <span
        className={css`
          font-size: 14px;
          font-family: ${fonts.body};
          line-height: 20px;
          color: ${colors.hurricane};
        `}
      >
        This user is not a part of any Book Clubs yet.
      </span>
      <Link
        to={marketingRoutes.home}
        className={css`
          color: ${colors.denim};
          font-size: 14px;
          font-weight: 600;
          text-decoration: none;
          line-height: 20px;
          margin-top: 4px;
          :after {
            display: none;
          }
        `}
      >
        Discover clubs to read together
      </Link>
    </FlexBox>
  )
}

export default ProfileClubsEmptyState
